'use strict';
var keyboardAccessibility = require('./keyboardAccessibility');

var clearSelection = function (element) {
    $(element).closest('.m-dropdown').children('.m-dropdown-menu').children('.top-category')
        .detach();
    $(element).closest('.m-dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
    $(element).closest('.m-dropdown.show').children('.m-dropdown-menu').attr('aria-hidden', 'true');
    $(element).closest('.m-dropdown.show').removeClass('show');
    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
    $(element).closest('li').detach();
};

module.exports = function () {
    var isDesktop = function (element) {
        return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
    };

    var mainContent = $('#maincontent');

    if ($('.promotion-container').length > 0) {
        $('.logo-nav-search-container').addClass('header-promo-exist');
    }
    $(document).on('click', '.promo-detail-container.active button', function (e) {
        e.preventDefault();
        var $curObj = $(this).closest('.promo-detail-container');
        $curObj.closest('.slick-list').removeClass('overflow-visible');
        $curObj.removeClass('active');
        if ($('.modal.fade.show').length > 0) {
            $('body, html').removeClass('modal-open');
            $('.modal.fade.show').remove();
            $('#header-container').removeAttr('style');
        }
        $(document).off("keydown.promoEsc");
    })

    function escListener() {
      $(document).on("keydown.promoEsc", function (e) {
        e.preventDefault();
        if (e.key === "Escape" || event.keyCode === 27) {
          $(".promo-detail-container.active button").trigger("click");
        }
      });
    }
    

    $(document).on('click', '.modal.fade.show', function () {
        $('.promo-detail-container.active button').trigger('click');
    });

    $('.promo-text span').on('click', function() {
        var $curObj = $(this).closest('.promo-text-section').find('.promo-detail-container');
        if ($curObj.hasClass('active')) {
            $curObj.removeClass('active');
            $curObj.closest('.slick-list').removeClass('overflow-visible');
            if ($('.modal.fade.show').length > 0) {
                $('body, html').removeClass('modal-open');
                $('#header-container').removeAttr('style');
                $('.modal.fade.show').remove();
            }
        } else {
            $curObj.addClass('active');
            escListener();
            $curObj.closest('.slick-list').addClass('overflow-visible');
            if ($('#header-container').hasClass('visible')) {
                $('#header-container').css({'position': 'fixed', 'top' : '0' });
            } else {
                $('#header-container').removeAttr('style');                
            }
            $('body').addClass('modal-open');
            if ($(window).width() < 768) {
                $('html').addClass('modal-open');
            }
            
            $('<div>', {
                id: 'promo-message-fade-bg',
                class: 'modal fade show',
                title: ''
            }).appendTo('.header-top-bar');        
        }
    });

    $(window).on('load', function () {
        if ($(window).width() < 1240) {
            const topCSSValue = $('.header-promotion-slot').height() + 5;
            $('.logo-section .slot-position').css('top', topCSSValue);
            $('.logo-section .slot-position').css('display', 'block' );
        }

        const $checkHeaderPromoContent = $('.promo-text-banner .header-promotion-slot');
        if ($checkHeaderPromoContent.length > 0) {
            $('.promo-text-banner').addClass('loaded');
        }
    });

    var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
    $('.header-banner .close').on('click', function () {
        $('.header-banner').addClass('d-none');
        window.sessionStorage.setItem('hide_header_banner', '1');
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $('.header-banner').removeClass('d-none');
    }

    keyboardAccessibility('.main-menu .nav-link, .main-menu .m-dropdown-link', {
        40: function (menuItem) { // down
            if (menuItem.hasClass('nav-item')) { // top level
                $('.navbar-nav .show').removeClass('show')
                    .children('.m-dropdown-menu')
                    .removeClass('show');
                menuItem.addClass('show').children('.m-dropdown-menu').addClass('show');
                menuItem.find('div > a')
                    .first()
                    .focus();
            } else {
                menuItem.removeClass('show').children('.m-dropdown-menu').removeClass('show');
                if (!(menuItem.next().length > 0)) { // if this is the last menuItem
                    menuItem.parent().parent().find('li > a') // set focus to the first menuitem
                        .first()
                        .focus();
                } else {
                    menuItem.next().children().first().focus();
                }
            }
        },
        39: function (menuItem) { // right
            if (menuItem.hasClass('nav-item')) { // top level
                menuItem.removeClass('show').children('.m-dropdown-menu').removeClass('show');
                $(this).attr('aria-expanded', 'false');
                menuItem.next().children().first().focus();
            } else if (menuItem.hasClass('m-dropdown')) {
                menuItem.addClass('show').children('.m-dropdown-menu').addClass('show');
                $(this).attr('aria-expanded', 'true');
                menuItem.find('ul > li > a')
                    .first()
                    .focus();
            }
        },
        38: function (menuItem) { // up
            if (menuItem.hasClass('nav-item')) { // top level
                menuItem.removeClass('show').children('.m-dropdown-menu').removeClass('show');
            } else if (menuItem.prev().length === 0) { // first menuItem
                menuItem.parent().parent().removeClass('show')
                    .children('.nav-link')
                    .attr('aria-expanded', 'false');
                menuItem.parent().children().last().children() // set the focus to the last menuItem
                    .first()
                    .focus();
            } else {
                menuItem.prev().children().first().focus();
            }
        },
        37: function (menuItem) { // left
            if (menuItem.hasClass('nav-item')) { // top level
                menuItem.removeClass('show').children('.m-dropdown-menu').removeClass('show');
                $(this).attr('aria-expanded', 'false');
                menuItem.prev().children().first().focus();
            } else {
                menuItem.closest('.show').removeClass('show')
                    .closest('li.show').removeClass('show')
                    .children()
                    .first()
                    .focus()
                    .attr('aria-expanded', 'false');
            }
        },
        27: function (menuItem) { // escape
            var parentMenu = menuItem.hasClass('show') ?
                menuItem :
                menuItem.closest('li.show');
            parentMenu.children('.show').removeClass('show');
            parentMenu.removeClass('show').children('.nav-link')
                .attr('aria-expanded', 'false');
            parentMenu.children().first().focus();
        },
        13: function (menuItem) {
            if (menuItem.hasClass('nav-item')) { // top level
                $('.navbar-nav .show').removeClass('show')
                    .children('.m-dropdown-menu')
                    .removeClass('show');
                menuItem.addClass('show').children('.m-dropdown-menu').addClass('show');
                menuItem.find('div > a')
                    .first()
                    .focus();
            } else {
                menuItem.removeClass('show').children('.m-dropdown-menu').removeClass('show');
            }
        }
    },
        function () {
            return $(this).parent();
        }
    );

    $('.m-dropdown:not(.disabled) [data-toggle="m-dropdown"]')
        .on('click', function (e) {
            if (!isDesktop(this)) {
                $('.modal-background').show();
                // copy parent element into current UL
                var li = $('<li class="m-dropdown-item top-category" role="button"></li>');
                var link = $(this).clone().removeClass('m-dropdown-toggle')
                    .removeAttr('data-toggle')
                    .removeAttr('aria-expanded')
                    .attr('aria-haspopup', 'false');
                li.append(link);
                var closeMenu = $('<li class="nav-menu"></li>');
                closeMenu.append($('.close-menu').first().clone());
                $(this).parent().children('.m-dropdown-menu')
                    .prepend(li)
                    .prepend(closeMenu)
                    .attr('aria-hidden', 'false');
                // copy navigation menu into view
                $(this).parent().addClass('show');
                $(this).attr('aria-expanded', 'true');
                $(link).focus();
                $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
                e.preventDefault();
            }
        })
        .on('mouseenter', function () {
            if (isDesktop(this)) {
                var eventElement = this;
                $('.navbar-nav > li').each(function () {
                    if (!$.contains(this, eventElement)) {
                        $(this).find('.show').each(function () {
                            clearSelection(this);
                        });
                        if ($(this).hasClass('show')) {
                            $(this).removeClass('show');
                            $(this).children('ul.m-dropdown-menu').removeClass('show');
                            $(this).children('.nav-link').attr('aria-expanded', 'false');
                        }
                    }
                });
                // need to close all the m-dropdowns that are not direct parent of current m-dropdown
                $(this).parent().addClass('show');
                $(this).siblings('.m-dropdown-menu').addClass('show');
                $(this).attr('aria-expanded', 'true');
                if ($(this).data("level") === 'top') {
                    mainContent.addClass('faded');
                }
            }
        })
        .parent()
        .on('mouseleave', function () {
            if (isDesktop(this)) {
                $(this).removeClass('show');
                $(this).children('.m-dropdown-menu').removeClass('show');
                $(this).children('.nav-link').attr('aria-expanded', 'false');
                if ($(this).data("level") === 'top') {
                    mainContent.removeClass('faded');
                }
            }
        });

    $('.navbar>.close-menu>.close-button').on('click', function (e) {
        e.preventDefault();
        $('.menu-toggleable-left').removeClass('in');
        $('.modal-background').hide();

        $('.navbar-toggler').focus();

        $('.main-menu').attr('aria-hidden', 'true');
        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');
        $('body').removeClass('mobile-menu-open');
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $('.navbar-nav').on('click', '.close-button', function (e) {
        e.preventDefault();
        $('.navbar-nav').find('.top-category').detach();
        $('.navbar-nav').find('.nav-menu').detach();
        $('.navbar-nav').find('.show').removeClass('show');
        $('.menu-toggleable-left').removeClass('in');

        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');

        $('.modal-background').hide();
        $('body').removeClass('mobile-menu-open');
    });

    $('.navbar-toggler').click(function (e) {
        e.preventDefault();
        $('.main-menu').toggleClass('in');
        $('.modal-background').show();

        $('.main-menu').removeClass('d-none');
        $('.main-menu').attr('aria-hidden', 'false');
        $('.main-menu').siblings().attr('aria-hidden', 'true');
        $('header').siblings().attr('aria-hidden', 'true');
        $('body').addClass('mobile-menu-open');

        $('.main-menu .nav.navbar-nav .nav-link').first().focus();
    });

    keyboardAccessibility('.navbar-header .user', {
        40: function ($popover) { // down
            if ($popover.children('a').first().is(':focus')) {
                $popover.next().children().first().focus();
            } else {
                $popover.children('a').first().focus();
            }
        },
        38: function ($popover) { // up
            if ($popover.children('a').first().is(':focus')) {
                $(this).focus();
                $popover.removeClass('show');
            } else {
                $popover.children('a').first().focus();
            }
        },
        27: function () { // escape
            $('.navbar-header .user .popover').removeClass('show');
            $('.user').attr('aria-expanded', 'false');
        },
        9: function () { // tab
            $('.navbar-header .user .popover').removeClass('show');
            $('.user').attr('aria-expanded', 'false');
        }
    },
        function () {
            var $popover = $('.user .popover li.nav-item');
            return $popover;
        }
    );

    $('.navbar-header .user').on('mouseenter focusin', function () {
        if ($('.navbar-header .user .popover').length > 0) {
            $('.navbar-header .user .popover').addClass('show');
            $('.user').attr('aria-expanded', 'true');
        }
    });

    $('.navbar-header .user').on('mouseleave', function () {
        $('.navbar-header .user .popover').removeClass('show');
        $('.user').attr('aria-expanded', 'false');
    });
    $('body').on('click', '#myaccount', function () {
        event.preventDefault();
    });
    // display specialty slot otherwise show global
    if ($('.contentslot-specialty').children().length > 0) {
        $('.contentslot-specialty').removeClass('d-none');
    } else {
        $('.contentslot-global-sp').removeClass('d-none');
    }

    function showMenu() {
        if (window.matchMedia('(min-width:1240px)').matches) {
            $(".header-center-block").addClass("header-main-menu");
            $('.header-main-menu .navbar-links .nav-item').on('mouseenter', function () {
                var currentMenuId = $(this).find(".nav-link").attr("id");
                $("#" + currentMenuId + "SubMenu").addClass("show-menu");
                adjustSubmenuWidth( "#" + currentMenuId + "SubMenu",'open');
            });

            $('.vl-flyout-nav__expander button').on('keydown click', function (e) {
                var keyCode = e.keyCode || e.which;
                if (keyCode == 13 || e.type == 'click') {
                    adjustSubmenuWidth("showmenu",'close');
                    $(".submenu-content").removeClass("show-menu");
                    $(".header-main-menu .nav-link").removeClass("active-link");
                    var currentMenuId = $(this).data("id");
                    $("#" + currentMenuId + "SubMenu").addClass("show-menu");
                    adjustSubmenuWidth( "#" + currentMenuId + "SubMenu",'open')
                    $("#" + currentMenuId + "SubMenu").find('.submenu-link').first().focus();
                }
            })

              $(".submenu-content .submenu-block > ul:first-child > li:first-child a").on('focusout', function (e) {
                var submenuParent = $(this).parents('.submenu-content')
                var secondSubmenuLink = $(submenuParent.find('a')[1]);
                var menuCategoryId = submenuParent.attr('id').replace("SubMenu", "");
                if (!$(e.relatedTarget).is(secondSubmenuLink) && !(e.relatedTarget).is('.submenu-link')) {
                    $("#" + menuCategoryId).focus();
                    adjustSubmenuWidth("showmenu",'close');
                    $(".submenu-content").removeClass("show-menu");
                }
             })
            $(".submenu-content .submenu-block > ul:last-child").each(function(){
                let element = $(this)
                element.find('a').last().on('focusout', function (e) {
                var submenuParent = $(this).parents('.submenu-content');
                var menuCategoryId = submenuParent.attr('id').replace("SubMenu", "");
                if (!$(e.relatedTarget).is('a')) { 
                $("#" + menuCategoryId).parent().next().children('a').focus();
                    adjustSubmenuWidth("showmenu",'close');
                    $(".submenu-content").removeClass("show-menu");
                }
             })
            });

            $('.header-main-menu .navbar-links .nav-item,.header-main-menu .submenu-content').on('mouseleave', function () {
                adjustSubmenuWidth("showmenu",'close');
                $(".submenu-content").removeClass("show-menu");
                $(".header-main-menu .nav-link").removeClass("active-link");
            });

            $('.header-main-menu .submenu-content').on('mouseenter', function () {
                var currentMenuId = $(this).attr('id');
                $(this).addClass("show-menu");
                adjustSubmenuWidth("#" + currentMenuId + "SubMenu",'open')
                var currentCat = $(this).attr("data-cat");
                $("#" + currentCat).addClass("active-link");
            });
        }
    }

    showMenu();
    function adjustSubmenuWidth(submenu,status) { //made for safari

        switch(status){
            case 'open':
                $(submenu + " .sub-menu-block").each(function () {
                  if ($(this).prop("scrollWidth") > $(this).width()) {
                    $(this).addClass('double-row');
                  }
                });
                break;
            case 'close':
                 $(submenu + " .sub-menu-block").each(function () {
                  if ($(this).hasClass('double-row')) {
                    $(this).removeClass('double-row');
                  }
                });
                break;
        }
    }

    $(window).on('resize', function (e) {
        handleScreenRatioChange();
        e.preventDefault();

        setTimeout(function () {
            showMenu();
        }, 100);
    });


    function handleScreenRatioChange() {
        var navbarCat = $('#navbar-cat');

        if (window.innerWidth < 1240 && navbarCat.length !== null) {
            navbarCat.addClass('d-none');
        } else if(navbarCat.length !== null) {
            navbarCat.removeClass('d-none');
        }
    }

    if($('#checkout-main').length < 1) {
        handleScreenRatioChange();
    }

    $('.menu-bar').click(function () {
        $('.submenu-content').removeClass("show");
        setTimeout(function () {
            $(".navbar-content").addClass("show-mobile-menu");
        }, 100);
        $("#navbar-cat").removeClass("d-none");
        $("#women").focus();
        $(".header-main-menu").prepend("<div class='menu-overlay-bg'></div>");
        $('body, html').addClass('overflow-hidden');
    });

    $('.navbar-links').on('click', '.nav-item.next-arrow', function () {
        var subMenuId = $(this).find('a.nav-link').attr('id');
        var title = $(this).find('a.nav-link').text();
        $('.navbar-content .mobile-subMenu-section').addClass("active-menu");
        $('.submenu-content').removeClass("show");
        $("#" + subMenuId + "SubMenu").addClass("show");
        $('#' + subMenuId + 'SubMenu .submenu-links.d-block > .submenu-item').each(function () {
            if ($(this).find('.sub-nav').length) {
                $(this).addClass("next-arrow");
            }
        })
        $('.mobile-subMenu-title').text(title);
    })

    $('.mobile-subMenu-section .mobile-subMenu-title').on('click', function () {
        $('.mobile-subMenu-section').removeClass("active-menu");
        $('.submenu-content.show').removeClass('show');
    })

    $('.mobile-subMenu-section').on('click', '.submenu-item.next-arrow', function (e) {
        $(this).parent().find('.sub-menu-block').addClass('active-menu');
    })
    $('.sub-menu-block .sub-menu-Title').on('click', function (e) {
        $(this).parents('.sub-menu-block').removeClass('active-menu');
    })
    $('.close-btn-block .close').click(function () {
        $('.sub-menu-block.active-menu').removeClass("active-menu");
        $('.mobile-subMenu-section.active-menu').removeClass("active-menu");
        $(".navbar-content").removeClass("show-mobile-menu");
        $(".menu-overlay-bg").remove();
        $("body, html").removeClass("overflow-hidden");

        setTimeout(function () {
            if(window.innerWidth < 1240){
                $("#navbar-cat").addClass("d-none");
            }
        }, 200);
    });

    $(window).on('orientationchange resize', function () {
        if ($(window).width() < 1240 && $('.navbar-content').hasClass('show-mobile-menu')) {
            $(".close-btn-block .close").trigger('click');
        }
    })

    $('.submenu-link').on('click', function (e) {
        if (window.matchMedia('(max-width:1239px)').matches) {
            if ($(this).hasClass('show')) {
                $(this).removeClass('show');
                $(this).closest('.submenu-item').find('.sub-nav').slideUp();
            } else {
                $(this).addClass('show');
                $(this).closest('.submenu-item').find('.sub-nav').slideDown();
            }
        }
    });

    $('.header-brands-logo-bar').ready(function () {
        var siteID = $('header.main-header').attr('data-siteid');
        var activeSiteTab = $('.header-brands-logo-bar').find('.' + siteID);
        activeSiteTab.addClass('active');
        var selectedLI= activeSiteTab.parents('li');
        selectedLI.insertBefore(".header-brands-logo-bar ul.top-menu li:eq(0)");
        if (activeSiteTab.parents('li').index() == 0) {
            activeSiteTab.parents('ul').children().eq(1).find('a').addClass('hide-bar')
        }
    });

    $('.navbar-container').ready(function () {
        $('.navbar-container .navbar-links a').each(function () {
            var subMenu_ID = $(this).attr('id');
            if ($("#" + subMenu_ID + "SubMenu").length) {
                $(this).parents('.nav-item').addClass('next-arrow');
            }
        })
    });
};